import { useLanguageStore, useUserStore } from '@/store';
import { useMenuStore } from '@/store/menuStore';
import { getMenuItems } from '@/utils/menu';
import { Layout } from '@contiple/antd-ds';
import { useEffect } from 'react';
import HeaderBar from './HeaderBar';
import MainContent from './MainContent';
import { ContentHeaderProvider } from './MainHeaderButton/ContentHeaderContext';
import SiderBar from './SiderBar';

const AppLayout = () => {
  const { user } = useUserStore();
  const { language } = useLanguageStore();
  const { setMenuState } = useMenuStore();
  useEffect(() => {
    const { menuItems, menuPathMap } = getMenuItems(user?.menuList || []);
    setMenuState(menuItems, menuPathMap);
  }, [user?.menuList, language]);

  return (
    <ContentHeaderProvider>
      <Layout style={{ minHeight: '100vh', minWidth: '1280px' }}>
        {/* GNB */}
        <HeaderBar />

        <Layout>
          {/* LNB */}
          <SiderBar />

          {/* Content */}
          <MainContent />
        </Layout>
      </Layout>
    </ContentHeaderProvider>
  );
};

export default AppLayout;
